import { AVAILABLE_THEMES } from './themeConstants';
export var getCustomTheme = function getCustomTheme(theme) {
  var themeToRender = AVAILABLE_THEMES[theme] || AVAILABLE_THEMES.defaultTheme;
  return {
    themeToRender: themeToRender
  };
};